import { ActRevaluationRequest } from "../../libs/core-api-requests/documents/actRevaluationRequest";
import { IActRevaluationCreateDTO, IActRevaluationFillWithRemnantsOnStoreDto, IActRevaluationFromStoreDTO, IActRevaluationGetDTO, IActRevaluationUpdateDTO, IActRevaluationValidateStoresDto, IActRevaluationViewDTO } from "../../libs/coreapi-dto/documents/ActRevaluation";
import { IActRevaluationItemGetDTO, IActRevaluationItemViewDTO } from "../../libs/coreapi-dto/documents/ActRevaluationItem";
import CoreApiService from "../../system/api/coreApiService";
import { DocumentDataProviderV2 } from "./Common/DocumentDataProviderV2";


export class ActRevaluationDataProvider extends DocumentDataProviderV2<IActRevaluationViewDTO, IActRevaluationGetDTO, IActRevaluationCreateDTO, IActRevaluationUpdateDTO, IActRevaluationItemViewDTO, IActRevaluationItemGetDTO> {

    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService;
    }

    getDataRequest(): Promise<ActRevaluationRequest> {
        return this._coreApiService.actRevaluationRequest;
    }

    createFromStoreMany(dto: IActRevaluationFromStoreDTO, callback?: (e) => void, failedCallback?: (e) => void) {
        this._coreApiService.actRevaluationRequest.then(r => r.createFromStoreMany(dto, (e) => {
            if (e.respType === 'isCompleted') {
                callback?.(e.data)
            }
            else
            {
                failedCallback?.(e)
                throw new Error(e.message.title);
            }
        }));
    }

    createFromStore(
        idStoreGlobal: string,
        lotsLimitPerDocumentNo: number = 150,
        remnantsType: string = "VatSourceOnly",
        calculateWithPricingModel: boolean = true,
        generateNewBarcodes: boolean = false,
        idPricingModel: string | null = null,
        callback?: (e) => void,
        failedCallback?: (e) => void) {

        this._coreApiService.actRevaluationRequest.then(r => r.createFromStore(
            idStoreGlobal,
            lotsLimitPerDocumentNo,
            remnantsType,
            calculateWithPricingModel,
            generateNewBarcodes,
            idPricingModel,
            (e) => {
                if (e.respType === 'isCompleted') {
                    callback?.(e.data)
                }
                else {
                    failedCallback?.(e)
                    throw new Error(e.message.title);
                }
            }));
    }

    validateStores(dto: IActRevaluationValidateStoresDto, callback?: (e) => void, failedCallback?: (e) => void) {
        this._coreApiService.actRevaluationRequest.then(r => r.validateStores(dto, (e) => {
            if (e.respType === 'isCompleted') {
                callback?.(e.data)
            }
            else
            {
                failedCallback?.(e)
                throw new Error(e.message.title);
            }
        }));
    }

    fillWithRemnantsOnStore(
            idDocumentGlobal: string,
            dto: IActRevaluationFillWithRemnantsOnStoreDto,
            callback: (e) => void,
            failedCallback?: (e) => void
    ) {
        this._coreApiService.actRevaluationRequest.then(r => r.fillWithRemnantsOnStore(idDocumentGlobal, dto, (e) => {
            if (e.respType === 'isCompleted') {
                callback?.(e.data)
            }
            else
            {
                failedCallback?.(e)
                throw new Error(e.message.title);
            }
        }));
    }

    deleteReserves(idDocumentGlobal: string,
        callback?: () => void,
        failedCallback?: (e) => void) {

        this._coreApiService.actRevaluationRequest.then(r => r.deleteReserves(idDocumentGlobal,
            (e) => {
                if (e.respType === 'isCompleted') {
                    callback?.()
                }
                else {
                    failedCallback?.(e)
                    throw new Error(e.message.title);
                }
            }));
    }
}